
import {Button, Col, Container, Image, Row} from 'react-bootstrap';
import Heading from '../layouts/Heading';
import SectionComposition from '../layouts/SectionComposition';
import { HeaderIconData } from '../data/HeaderIconData';
import { ServiceData } from '../data/ServiceData';
import Service from '../layouts/Service';
import  Icon from '../layouts/Icon';
import Project from '../layouts/Project';
import { ProjectData } from '../data/ProjectData';
import ProfileCard from '../layouts/ProfileCard';
import { TeamData } from '../data/TeamData';
import OpenNewTab from '../hooks/OpenNewTab';
import PageTitle from '../hooks/PageTitle';


const Home = () => {
    const {openInNewTab} = OpenNewTab();

  return (
    <main>
        <PageTitle title="" />
        {/* Header Section Start*/}
        <SectionComposition bgColor="off-white">
            <Container>
                <Row>
                    <Col lg={8}>
                        <h6 className="fs-2" data-aos="fade-right">Assalamualaikum,I'm</h6>
                        <h1 className="display-4 fw-bold" data-aos="fade-left">MD. MILTON HOSSAIN</h1>
                        <p className='fs-4' data-aos="zoom-in">Full Stack Web Application Developer</p>

                        <div className="py-3">
                            <Button variant="outline-success" className='me-1' data-aos="fade-up-right" onClick={(e) => openInNewTab("https://wa.me/+8801621000361")}>HIRE ME</Button>
                            <Button variant="outline-success" className='me-1' data-aos="fade-up-left" onClick={(e) => openInNewTab("asset/file/cv/milton.pdf")}>DOWNLOAD CV</Button>
         
                        </div>      
                        <div className="socials mt-4" data-aos="fade-up">
                            {
                                HeaderIconData.map( (item, index) => {
                                    return  <Icon key={index} icon={item.icon} link={item.link}/>
                                })
                            }
                        </div>
                    </Col>  

                    <Col lg={4} data-aos="zoom-in">
                        <Image className='w-100' src="asset/img/header/milton.png" alt="" height="350"/>
                    </Col> 
                </Row>
            </Container> 
        </SectionComposition>   
        {/* Header Section End*/}

        {/* Service Section Start */}
        <SectionComposition bgColor="">
              <Heading headingTitle = "Our Services" />
              <Container className="container-xxl">
                  <Container>
                      <Row className="g-4">
                        {
                            ServiceData.map( (item, index) => {
                                return <Service key={index} icon={item.icon} img={item.img} title={item.title} description={item.description}/>
                            })
                        }

                      </Row>
                  </Container>
              </Container>

          </SectionComposition>
        {/* Service Section End */}

           {/* Project Section Start */}
          <SectionComposition bgColor="off-white">
             <Heading headingTitle = "Our Projects" />
                <Container fluid>
                    <Container>
                        <Row className="g-4">
                            {
                                ProjectData.map( (item, index) => {
                                    return <Project key={index} title={item.title} img={item.img} link={item.link} />
                                })
                            }
                           
                        </Row>
                    </Container>
                </Container>

           </SectionComposition>
        {/* Project Section End */}

           {/* Team Section Start */}
           <SectionComposition bgColor="">
              <Heading headingTitle = "Our Team" />

              <Container fluid>
                <Container>
                    <Row className="g-4">
                        {
                            TeamData.map( (item, index) => {
                                return  <ProfileCard key={index} name={item.name} img={item.img} designation={item.designation} facebook={item.facebook} github={item.github} linkedIn={item.linkedIn}  />
                            })
                        }
                    </Row>
                </Container>
              </Container>
          </SectionComposition>
           {/* Team Section End */}
    </main>
  )
}

export default Home